import type { SignatureDocumentSummaryDto } from '@bhops/shared';

// 서명 관리 검색(2026-09-23 오너 요청). 목록은 한 번에 다 받아 오므로(페이지 없음) 화면에서
// 바로 거른다 — 치는 즉시 좁혀지고, 서버의 권한 범위 조건과 섞일 일이 없다.
//
// 찾는 곳: 문서명(고객사_유형_날짜) · 양식명 · 고객사 · 로봇 시리얼 · 서명자 이름·전화.
// 띄어 쓴 여러 낱말은 **모두** 맞아야 한다(예: "그린 312" = 그린리조트이면서 312 로봇).
// 대소문자·띄어쓰기·하이픈·# 은 가리지 않는다(시리얼 "#312", 전화 "010-1234-5678").

function norm(s: string): string {
  return s.toLowerCase().replace(/[\s\-#]/g, '');
}

function haystack(d: SignatureDocumentSummaryDto): string {
  const parts: string[] = [d.displayName, d.templateName, d.customerName ?? ''];
  if (d.robotSerial) parts.push(d.robotSerial);
  for (const r of d.robots ?? []) if (r.serial) parts.push(r.serial);
  for (const s of d.signatories ?? []) parts.push(s.name ?? '', s.phone ?? '');
  return norm(parts.join('|'));
}

export function filterSignDocuments(
  rows: SignatureDocumentSummaryDto[],
  query: string,
): SignatureDocumentSummaryDto[] {
  const terms = query.split(/\s+/).map(norm).filter(Boolean);
  if (terms.length === 0) return rows;
  return rows.filter((d) => {
    const h = haystack(d);
    return terms.every((t) => h.includes(t));
  });
}
